import { apiFetch, type AjaxResult } from './http';

export interface InviteOverview {
  referralCode: string;
  inviteLink: string;
  registerRewardSearchTimes: number;
  searchPointsCost: number;
  registerRewardPoints: number;
  totalInvited: number;
}

export function fetchInviteOverview(): Promise<AjaxResult<InviteOverview>> {
  return apiFetch<InviteOverview>('/api/app/invite/overview', { method: 'GET', auth: true });
}
